/**
 * DEMO MODE: el root redirige al store admin del tenant demo.
 * El "Platform Dashboard" (vista superadmin) queda accesible navegando manualmente
 * pero no es la primera impresión que queremos para el live demo.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/')({
  beforeLoad: () => {
    throw redirect({ to: '/store/$id', params: { id: 'tnt_demo' } })
  },
})
